module.exports = __webpack_public_path__ + "static/education-primary-circle-31cf60163d82839221abd81df855dfd2.png";